import { object, string } from 'yup';
import { BaseModel } from './base.model';
import { isValidEmail, JsonObject, UiOption } from '../helpers';

export type PartnerUserRole = 'partner:owner' | 'partner:admin' | 'partner:auditor';

export const PartnerRoleLabels: Record<PartnerUserRole, string> = {
  'partner:owner': 'Owner',
  'partner:admin': 'Admin',
  'partner:auditor': 'Auditor',
};

export const PartnerRoleOptions: UiOption[] = Object.keys(PartnerRoleLabels).map((value) => ({
  value,
  label: PartnerRoleLabels[value as PartnerUserRole],
}));

export class PartnerUserModel extends BaseModel {
  orgId: string;
  name: string;
  email: string;
  role: PartnerUserRole;

  schema = object({
    name: string().required('Name is required'),
    email: string()
      .test('email', 'Please enter a valid email address', isValidEmail)
      .required('Please enter an email address'),
    role: string()
      .oneOf(['partner:owner', 'partner:admin', 'partner:auditor'])
      .required('Please choose a valid role'),
  });

  constructor(props: JsonObject = {}) {
    super(props);

    const data = props as Record<keyof PartnerUserModel, string>;

    this.orgId = data.orgId || '';
    this.name = data.name || '';
    this.email = data.email || '';
    this.role = data.role ? (data.role as PartnerUserRole) : 'partner:auditor';
  }

  get emailDomain(): string {
    return this.email.split('@')[1];
  }
}
